module.exports = __webpack_public_path__ + "img/SKMJ_drill1.e7e1fea5.jpg";